import { enableProdMode, inject, NgZone, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { environment } from './environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { CorrelationIdInterceptor } from './app/core/correlation-id-interceptor';
import { HttpErrorInterceptor } from './app/core/http-error-interceptor';
import { MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalBroadcastService, MsalGuard, MsalInterceptor, MsalService } from '@azure/msal-angular';
import { AuthConfigService, MSALGuardConfigFactory, MSALInstanceFactory, MSALInterceptorConfigFactory } from './app/authentication/auth-config.service';
import { AuthService } from './app/authentication/auth.service';
import { AppShellStore } from './app/app-shell.store';
import { AppShellSignalRStore } from './app/app-shell-signalr.store';
import { provideRouter } from '@angular/router';
import { APP_ROUTES } from './app/app.routes';

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(),
        provideRouter(APP_ROUTES),
        provideHttpClient(
            withInterceptorsFromDi(),
            withInterceptors([CorrelationIdInterceptor, HttpErrorInterceptor]),
        ),
        provideAppInitializer(() =>
            inject(AuthConfigService).loadEnvironment()
        ),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MsalInterceptor,
            multi: true,
        },
        {
            provide: MSAL_INSTANCE,
            useFactory: MSALInstanceFactory,
            deps: [AuthConfigService],
        },
        {
            provide: MSAL_GUARD_CONFIG,
            useFactory: MSALGuardConfigFactory,
        },
        {
            provide: MSAL_INTERCEPTOR_CONFIG,
            useFactory: MSALInterceptorConfigFactory,
            deps: [AuthConfigService],
        },
        MsalService,
        MsalBroadcastService,
        MsalGuard,
        AuthConfigService,
        AuthService,
        AppShellStore,
        AppShellSignalRStore,
    ],
});
